import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideToastr, ToastrModule } from 'ngx-toastr';

import { routes } from './app.routes';
import { AuthInterceptor } from './core/interceptors/auth.interceptor';
import {BrowserAnimationsModule, provideAnimations} from '@angular/platform-browser/animations';
import { authInterceptorFn } from './core/interceptors/auth.interceptor-fn';
import { provideStore } from '@ngrx/store';
import { permissionReducer } from './core/permissions/permission.reducer';
import { provideProtractorTestingSupport } from '@angular/platform-browser';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { environment } from '../environment/environment'
import {QuillModule} from 'ngx-quill';;


export const appConfig: ApplicationConfig = {
  providers: [
    provideHttpClient(withInterceptors([authInterceptorFn])),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideToastr(),
    provideProtractorTestingSupport(),
    provideAnimations(),
    importProvidersFrom(BrowserAnimationsModule, ToastrModule.forRoot(), QuillModule.forRoot(),),
    AuthInterceptor,
    provideStore({
      permissions: permissionReducer,
    }),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideStorage(() => getStorage())
  ],
};
